import { NETWORK_ICONS, UNKNOWN_KEY } from '@/config';

export function getIconByNetwork(network: string) {
  const iconSrc = NETWORK_ICONS[network];

  if (!iconSrc) {
    return NETWORK_ICONS[UNKNOWN_KEY];
  }

  return iconSrc;
}

